import { RequirementSampleMaturityAssignmentResponse, RequirementSampleMaturityAssignmentListResponse, CreateRequirementSampleMaturityAssignmentRequest } from "@/types/requirementSampleMaturityAssignmentTypes";
import { Client } from "./client";
import { FusaReply } from "@/types/replyTypes";

export class RequirementSampleMaturityAssignmentFrontendController {
  client: Client;

  constructor(client?: Client) {
    this.client = client || new Client();
  }

  readAllByRequirementId(requirementId: string): Promise<RequirementSampleMaturityAssignmentListResponse> {
    return this.client.read(`/api/requirement-sample-maturity-assignments/requirement/${requirementId}`);
  }

  create(data: CreateRequirementSampleMaturityAssignmentRequest): Promise<RequirementSampleMaturityAssignmentResponse> {
    return this.client.create('/api/requirement-sample-maturity-assignments', data);
  }

  delete(id: string): Promise<FusaReply> {
    return this.client.delete(`/api/requirement-sample-maturity-assignments/${id}`);
  }
}
